export enum EPlaces {
    cloud = 'cloud',
    attach = 'attach',
    public = 'public',
}

export enum ESources {
    desktop = 'desktop',
    touch = 'touch',
}
